module.exports = __webpack_public_path__ + "static/logo_64px-34cddc3c49917ec3fbbef4c0aab0e2b3.png";